// import components
import { LinearProgress, Link, Typography } from '@mui/material';

// import external libraries
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import styles
import { StyledBoxFlexCenterSpaceBetween } from 'components/shared/Box/Box.styles';
import {
  StyledCalculatedProgressBox,
  StyledErrorBox,
  StyledLinearProgressBox,
  StyledYearCloseTitleBox,
  StyledYearClosureProgressBox
} from './YearClosureProgress.styles';

// import types
import { YearClosureProgressProps } from './YearClosureProgress.types';
import { Icon } from '@sdb/planning-ui';

export const YearClosureProgress = ({
  progress,
  title,
  errors,
  onErrorClick
}: YearClosureProgressProps) => {
  const { t } = useTranslation('common');
  const [calculatedProgress, setCalculatedProgress] = useState(0);

  useEffect(() => {
    const calculated = Math.round(
      (progress.dutyLinesProgress / progress.dutyLinesTotal) * 100
    );
    setCalculatedProgress(isNaN(calculated) ? 100 : calculated);
  }, [progress]);

  return (
    <StyledYearClosureProgressBox>
      {errors && errors.length > 0 ? (
        <Icon type="xmark" fontSize="small" color="error" />
      ) : (
        <Icon type="check" fontSize="small" color="success" />
      )}
      <StyledYearCloseTitleBox>{title}</StyledYearCloseTitleBox>
      <StyledBoxFlexCenterSpaceBetween>
        <StyledLinearProgressBox>
          <LinearProgress variant="determinate" value={calculatedProgress} />
        </StyledLinearProgressBox>
        <StyledCalculatedProgressBox>
          <Typography variant="body2" color="text.secondary">
            {calculatedProgress} %
          </Typography>
        </StyledCalculatedProgressBox>
        {errors && errors.length > 0 ? (
          <Link component="button" variant="body2" onClick={onErrorClick}>
            {errors.length} {t('errors')}
          </Link>
        ) : (
          <StyledErrorBox>
            {errors?.length} {t('errors')}
          </StyledErrorBox>
        )}
      </StyledBoxFlexCenterSpaceBetween>
    </StyledYearClosureProgressBox>
  );
};
